module.exports = __webpack_public_path__ + "img/icon_home02_hover.9df494c2.png";